import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useDispatch } from 'react-redux'
import { setCredentials } from './authSlice'
import { useLoginMutation } from './authApiSlice'
import { showSpinner, hideSpinner } from '../../components/componentSlice'

import { Modal } from "antd"
import './LoginRevamp.css'

const LoginRevamp = ({ isModalOpen, onClose }) => {

    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [errorMessage, setErrorMessage] = useState("dfgdfgg")

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [login, { isLoading }] = useLoginMutation()

    useEffect(() => {
        setErrorMessage("")
    }, [username, password])

    const onSubmit = async (e) => {
        e.preventDefault()
        setErrorMessage("")
        try {
            const loginResponse = await login({ username, password }).unwrap()
            console.log("loginResponse", loginResponse)
            if(loginResponse && loginResponse["user"]) {
                dispatch(setCredentials(loginResponse["user"]))
                setUsername("")
                setPassword("")
                navigateAfterLogin()
            } else if(loginResponse && loginResponse["error"]) {
                setErrorMessage(loginResponse["error"]);
            }
        } catch(err) {
            console.log(err)
            if(!err.status) {
                setErrorMessage("No Server Response")
            } else if(err.status === "FETCH_ERROR") {
                setErrorMessage("No Server Response")
            } else if(err.status === 400 || err.status === 401) {
                setErrorMessage("Incorrect Username or Password")
            } else {
                setErrorMessage(err.data?.message)
            }
        }
    }

    const navigateAfterLogin = async () => {
        navigate("/verify")
    }

    useEffect(() => {
        if(isLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isLoading])


    return (
        <Modal open={isModalOpen} onCancel={() => onClose()} footer={[]}>
            <div className="login-content">
                <div className="login-header">
                    <h2>Welcome Back</h2>
                    <p>Sign in to your Advisors Reserve account</p>
                </div>
                <p className='errorMessage'>{errorMessage}</p>
                <form onSubmit={(e) => onSubmit(e)}>
                    <div className="form-group">
                        <label for="username">Username</label>
                        <input className="inpt" type="username" id="username" name="username" required  value={username} onChange={(e) => setUsername(e.target.value)}></input>
                    </div>

                    <div className="form-group">
                        <label for="password">Password</label>
                        <input className="inpt" type="password" id="password" name="password" required value={password} onChange={(e) => setPassword(e.target.value)}></input>
                    </div>

                    <div className="form-group">
                        <button className="crm-button">Sign In</button>
                    </div>
                </form>

                <div className="login-footer">
                    <p>If you forgot your password please email info@beyondadvising.com</p>
                </div>
            </div>
        </Modal>
    )
}

export default LoginRevamp